import { envMode, envModes } from '$config/env'

export async function registerFirebaseServiceWorker() {
  if ('serviceWorker' in navigator && envMode === envModes.PRODUCTION) {
    return navigator.serviceWorker.register('/firebase-messaging-sw.js', {
      scope: '/firebase-cloud-messaging-push-scope',
    })
  }
  return undefined
}
